// React-Screen CChangesPanel - Strangler Phase 5 (entschalt).
// Runbook: tools/REACT-STRANGLER.md.
// ENTSCHALT am 23.8.2026 (Nutzer-Vorgabe: keine Huellen mehr, verbindlich
// sind Pixelgleichheit und 100% Funktionalitaet). React rendert die
// Knoepfe jetzt selbst ueber den gemeinsamen Baustein SecondaryPanel;
// der Legacy-Widget-Baum aus LYT_secondaryPanel.xml kommt nicht mehr vor.
// Die HANDLER sind weiter ueber spec.legacyMethods WOERTLICH uebernommen
// (Bridge-Vertrag 8) - `this`/`me` ist die Bridge.
import { defineReactScreen } from '../bridge.js';
import { SecondaryPanel } from '../secondaryPanel.jsx';

const legacy = {};


legacy.setMain = function (main)
{
    this.Main = main;
}

legacy.setCallback = function ()
{
    POS.events.setOnClickEventCallback(this, this.disappear, true);
}

legacy.disappear = function (me)
{
    me.Main.lastSubmenuId = "CH";
    window.setTimeout(me.Main.restoreLastSubmenuId, 0, me.Main);
    /*me.properties.styles.visibility = "hidden";
    me.reStyle();*/
	document.getElementById(me.id).style.visibility="hidden";
}

legacy.productChange = function (component, parameters)
{
    var me = POS.getComponentById (parameters[0]);

    if (! me.testConditions(false))
        return;

    /*privMan.enablePrivilege (privList);*/

    var bonId = me.Main.BonManager.currentBonId;

    var sql = "SELECT Foreign_ID, Qty FROM BONE WHERE BON_ID = " + bonId +
        " AND Type = 'POS'";

    var r = POS.SQLiteCon.execute(sql);
	$.when(r).then(function(rows) {
    //var prodId = r.getColumnByName("Foreign_ID");
    var prodId = rows[0].Foreign_ID;
	var totalQty = 0;

    var allSameType = true;

   // for (i = 0; i < r.recordCount(); i++)
    for (window.i = 0; i < rows.length; window.i++)
    {
        //if (r.getColumnByName("Foreign_ID") != prodId)
		if ((rows[i].Foreign_ID) != prodId)
        {
            allSameType = false;
            break;
        }
		
		 totalQty+= parseFloat(rows[i].Qty);

       // totalQty+= parseFloat(r.getColumnByName("Qty"));
        //r.moveNext();
    }

    if (!allSameType)
    {
        var text = POS.lang.getText("MESSAGES", "ONLY_ONE_PRODUCT_TYPE");
        POS.message.show (text, "warning", "");
    }
    else
    {
        var cmp = me.Main.addChild (CProductSelectMode);
        cmp.prodId = prodId;
        cmp.prodQty = totalQty;
        cmp.draw ();
    }
});
   // r.free();
}

/*legacy.productRecovery = function (component, parameters)
{
    var me = POS.getComponentById (parameters[0]);

    if (! me.testConditions(false))
        return;

    var text = POS.lang.getText("MESSAGES", "CONF_RECOVER_PRODUCTS");
    POS.message.show (text, "question", "YESNO", me, me.doProductRecovery);
}

legacy.doProductRecovery = function (me, result)
{
    if (result != "YES")
        return;

    me.Main.BonManager.productRecovery();
}*/

legacy.productExpiration = function (component, parameters)
{
    var me = POS.getComponentById (parameters[0]);

    if (! me.testConditions(false))
        return;

    var text = POS.lang.getText("MESSAGES", "CONF_EXPIRATE");
    POS.message.show (text, "question", "YESNO", me, me.doProductExpiration);
}

legacy.doProductExpiration = function (me, result)
{
    if (result != "YES")
        return;

    me.Main.BonManager.productExpiration();
}

legacy.separateBunch = function (component, parameters)
{
    var me = POS.getComponentById (parameters[0]);

    if (! me.testConditions(false))
        return;


    var text = POS.lang.getText("MESSAGES", "CONF_SEPARATE_BUNCH");
    POS.message.show (text, "question", "YESNO", me, me.doSeparateBunch);
}

legacy.doSeparateBunch = function (me, result)
{

    if (result != "YES")
        return;

    /*privMan.enablePrivilege (privList);*/

    var bonId = me.Main.BonManager.currentBonId;

    var sql = "SELECT Foreign_ID, EAN, Qty FROM BONE INNER JOIN PROD ON " + 
        "BONE.Foreign_ID = PROD.PROD_ID WHERE BONE.BON_ID = " +
        bonId + " AND BONE.Type = 'POS' AND Cancelled = 0";

	$.when(POS.SQLiteCon.execute(sql)).then(function(rows) {
			var barcode = rows[0].EAN;
			var qty = parseFloat(rows[0].Qty);

			if (rows.length != 1 || barcode.length != 12 || qty != 1)
			{
				//r.free();
				var text = POS.lang.getText("MESSAGES", "BUNCH_SEPARATE_NOT_POSSIBLE");
				POS.message.show (text, "warning", "");
				return;
			}

			var prodId = rows[0].Foreign_ID;
			me.Main.BonManager.separateBunch(prodId);

    //r.free();
	});
}

legacy.presentBunch = function (component, parameters)
{
    var me = POS.getComponentById (parameters[0]);

    if (! me.testConditions(false))
        return;

    var qty = me.getQuantity(me.Main.vacuumInfoValue(me.Main));

    if (!qty)
        return;

    if (qty == 1)
        var text = POS.lang.getText("MESSAGES", "CONF_MAKE_PRESENT_BUNCH");
    else
        text = POS.lang.getText("MESSAGES", "CONF_MAKE_PRESENT_BUNCH_X_TIMES").replace("%X%", qty);

    POS.message.show (text, "question", "YESNO", me, me.doPresentBunch);

    me.qty = qty;
}

legacy.doPresentBunch = function (me, result)
{

    if (result != "YES")
        return;

    var sum = me.Main.BonManager.getSumArray();
    me.Main.BonManager.addNewBunch(sum[3], "Geschenktopf", me.qty);
}

legacy.getQuantity = function (qty)
{
    if (qty == "" || qty == 0)
        qty = 1;

    qty = Math.floor(parseFloat(qty));

    if (qty < 1)
        return null;
    else
    {
        if (qty > 20)
        {
            var text = POS.lang.getText("MESSAGES", "TOO_MANY_BUNCHES");
            POS.message.show (text, "warning", "");
            return null;
        }
        return qty;
    }
}

legacy.preNewBunch = function (component, parameters)
{
    var me = POS.getComponentById (parameters[0]);
	var includesBunch=false;
	var Entry=me.Main.BonManager.currentBon;
	    var iterator = function it(i) {
        if (i < Entry.length) {
            if (Entry[i].cancelled == false && Entry[i].type != "BFS") {
				if (Entry[i].text1.startsWith('Biedermeier') || Entry[i].text1.startsWith('Geschenk')){
					includesBunch=true;
					return;
				}
				console.log("Includes Bunch!")
            }
            iterator(i + 1);
        }
    }
    iterator(0);
	if (includesBunch){
			var text = "Bitte den alten Strauss erst zerlegen, um damit einen neuen Strauss zu machen!";
            POS.message.show (text, "warning", "");
			return;
	}
    me.newBunch(me, "screen");
}

legacy.newBunch = function (me, from)
{
    if (! me.testConditions(true))
        return;

    if (from == "funk")
        var qty = 1;
    else
        qty = me.getQuantity(me.Main.vacuumInfoValue(me.Main));

    if (!qty)
        return;

    var substStrings = new Array();

    if (qty == 1)
    {
        var textScreen = POS.lang.getText("MESSAGES", "CONF_MAKE_BUNCH");
        var textFunk = "CONF_MAKE_BUNCH";
    }
    else
    {
        textScreen = POS.lang.getText("MESSAGES", "CONF_MAKE_BUNCH_X_TIMES").replace("%X%", qty);
        textFunk = "CONF_MAKE_BUNCH_X_TIMES";
        substStrings[3] = qty + POS.lang.getText("SCANNER", "CONF_MAKE_BUNCH_X_TIMES_4.5");
    }

    // Der zweite Aufrufer war der Funkscanner (from == "funk"); er ist am
    // 26.8.2026 entfallen, damit bleibt nur "screen".
    if (from == "screen")
        POS.message.show (textScreen, "question", "YESNO", me, me.doNewBunch);
    else
        POS.message.save (me.Main.UID, textScreen, "question", "YESNO", me, me.doNewBunch);


    me.qty = qty;
}

legacy.doNewBunch = function (me, result)
{
    if (result != "YES")
    {
        // Hier stand der Funkscanner-Aufruf; das return steuert den Ablauf
        // und bleibt.
        return;
    }

    var sum = me.Main.BonManager.getSumArray();
    me.Main.BonManager.addNewBunch(sum[3], "Geschenkstrau&szlig;", me.qty);
}

legacy.newBunchWithPrice = function (component, parameters)
{
    var me = POS.getComponentById (parameters[0]);
    var mode = parameters[1];

    if (! me.testConditions(false))
        return;

    if (mode == "NEW_PRICE")
    {
        var prodName = me.Main.BonManager.getProductName();
        if (! prodName)
        {
            var text = POS.lang.getText("MESSAGES", "ONLY_ONE_POSITION");
            POS.message.show (text, "warning", "");
            return;
        }
    }
    else
        prodName = mode;

    var qty = me.getQuantity(me.Main.vacuumInfoValue(me.Main));

    if (!qty)
        return;

    me.qty = qty;
    me.prodName = prodName;

    if (qty == 1)
    {
        me.doNewBunchWithPrice(me, "YES");
        return
    }
    else
    {
        if (mode == "NEW_PRICE")
            text = POS.lang.getText("MESSAGES", "CONF_MAKE_NEW_PRICE_X_TIMES").replace("%X%", qty);
        else
            text = POS.lang.getText("MESSAGES", "CONF_MAKE_DRY_BUNCH_X_TIMES").replace("%X%", qty);
    }

    POS.message.show (text, "question", "YESNO", me, me.doNewBunchWithPrice);
}

legacy.doNewBunchWithPrice = function (me, result)
{

    if (result != "YES")
        return;

    me.Main.cmpPriceInput.mode = "bunch";
    me.Main.cmpPriceInput.type = me.prodName;
    me.Main.cmpPriceInput.qty = me.qty;
    me.Main.cmpPriceInput.show();
}

legacy.testConditions = function (tellScanner)
{
    if (this.Main.BonManager.isBonEmpty())
    {
        var text = POS.lang.getText("MESSAGES", "NO_BON");

        if (! tellScanner)
        {
            POS.message.show (text, "warning", "");
            return false;
        }

        if (POS.sessions.currentSession == this.Main.UID)
        {
            var text = POS.lang.getText("MESSAGES", "NO_BON");
            // Der Rueckruf war restoreScannerMessage (Funkscanner, entfallen
            // am 26.8.2026). gotResult ruft nur auf, was eine Funktion ist -
            // ohne Rueckruf passiert also genau das, was vorher ohne
            // angeschlossenen Scanner passierte: nichts.
            POS.message.show (text, "warning", "");
        }
        else
            POS.message.save (this.Main.UID, text, "warning", "OK");
    

        return false;
    }

    return true;
}



function CChangesPanelScreen({ bridge }) {
  const t = bridge.t;

  const knoepfe = [
    { text: t('BUTTONS', 'NEW_BUNCH'), handler: bridge.preNewBunch },
    { text: t('BUTTONS', 'PRESENT_BUNCH'), handler: bridge.presentBunch },
    { text: t('BUTTONS', 'DRY_BUNCH'), handler: bridge.newBunchWithPrice, param1: 'Biedermeierstrau&szlig;' },
    { text: t('BUTTONS', 'SEPARATE_BUNCH'), handler: bridge.separateBunch },
  ];

  return <SecondaryPanel bridge={bridge} spalten={4} knoepfe={knoepfe} />;
}

// Legacy-Konstruktor zum Uebertragen (addclass/htmlType/rootStyles/Felder):
// function CChangesPanel (id)
// {
//     this.construct (id,"secondaryPanel CChangesPanel");
// 
//     this.htmlType = "span";
// 
//     this.properties =
//     {
//         styles: {}
//     }
// 
//     this.Main = null;
// }
export const CChangesPanel = defineReactScreen({
  className: 'CChangesPanel',
  addclass: 'secondaryPanel CChangesPanel',
  htmlType: 'span',
  Screen: CChangesPanelScreen,
  // Kein prepare/mountLegacy mehr: das Legacy-prepare baute den
  // Widget-Baum aus LYT_secondaryPanel.xml, den rendert jetzt React
  // selbst (SecondaryPanel). Uebrig bleiben die Methoden - die sind
  // WOERTLICH die alten.
  legacyMethods: legacy,
});
